(function () {
  const ENABLE_PARAM = 'upsell';
  const ENABLE_VALUE = 'hydrate';

  const COPY = {
    en: {
      hydrateLink: 'What is Hydrate?',
      hydrateAdd: 'ADD',
      hydrateRemove: 'REMOVE',
      bottleAdd: 'ADD',
      bottleFreePrice: 'Free',

      '1-one-time': {
        title: 'Need hydration too? Add Hydrate',
        body: '10 Hydrate sticks alongside your Kick.',
      },

      '3-one-time': {
        title: 'Need hydration too? Add Hydrate',
        body: '10 Hydrate sticks alongside your Kick 3 boxes.',
      },

      '3-subscription': {
        title: 'Need hydration too? Add Hydrate',
        body:
          '10 Hydrate sticks with your first Kick delivery. One-time add-on.',
      },

      '6-one-time': {
        title: 'Need hydration too? Add Hydrate',
        body: '10 Hydrate sticks alongside your Kick 6 boxes.',
      },

      '6-subscription': {
        title: 'Need hydration too? Add Hydrate',
        body:
          '10 Hydrate sticks with your first Kick delivery. One-time add-on.',
      },

      popup: {
        title: 'Hydration built for hard sessions.',
        text:
          'Hydrate is our electrolyte stick with 593 mg sodium, 402 mg potassium and 81 mg magnesium per serving. One stick in water before, during or after training to help replace what you lose through sweat.',
        sodium: 'sodium per stick',
        potassium: 'potassium per stick',
        magnesium: 'magnesium per stick',
        add: 'ADD HYDRATE',
        remove: 'REMOVE HYDRATE',
      },
    },

    fr: {
      hydrateLink: "C'est quoi Hydrate ?",
      hydrateAdd: 'AJOUTER',
      hydrateRemove: 'RETIRER',
      bottleAdd: 'AJOUTER',
      bottleFreePrice: 'Offerte',

      '1-one-time': {
        title: "Besoin d'hydratation aussi ? Ajoutez Hydrate",
        body: '10 sticks Hydrate avec votre Kick.',
      },

      '3-one-time': {
        title: "Besoin d'hydratation aussi ? Ajoutez Hydrate",
        body: '10 sticks Hydrate avec vos 3 boîtes Kick.',
      },

      '3-subscription': {
        title: "Besoin d'hydratation aussi ? Ajoutez Hydrate",
        body:
          '10 sticks Hydrate avec votre première livraison Kick. Ajout unique.',
      },

      '6-one-time': {
        title: "Besoin d'hydratation aussi ? Ajoutez Hydrate",
        body: '10 sticks Hydrate avec vos 6 boîtes Kick.',
      },

      '6-subscription': {
        title: "Besoin d'hydratation aussi ? Ajoutez Hydrate",
        body:
          '10 sticks Hydrate avec votre première livraison Kick. Ajout unique.',
      },

      popup: {
        title: "L'hydratation pensée pour les efforts exigeants.",
        text:
          "Hydrate est notre stick d'électrolytes avec 593 mg de sodium, 402 mg de potassium et 81 mg de magnésium par portion. Un stick dans l'eau avant, pendant ou après l'entraînement pour aider à remplacer ce que vous perdez par la transpiration.",
        sodium: 'de sodium par stick',
        potassium: 'de potassium par stick',
        magnesium: 'de magnésium par stick',
        add: 'AJOUTER HYDRATE',
        remove: 'RETIRER HYDRATE',
      },
    },
  };

  /* ========================================================
     General
     ======================================================== */

  const isEnabled = (component) => {
    const params = new URLSearchParams(
      window.location.search
    );

    const enabledByUrl =
      params.get(ENABLE_PARAM) ===
      ENABLE_VALUE;

    const enabledByTemplate =
      component?.dataset
        .templateUpsellEnabled ===
      'true';

    return (
      enabledByUrl ||
      enabledByTemplate
    );
  };

  const getLocale = () => {
    const lang = String(
      document.documentElement.lang || ''
    ).toLowerCase();

    return lang.startsWith('fr')
      ? 'fr'
      : 'en';
  };

  const formatMoney = (cents) => {
    const amount = Number(cents);

    if (!Number.isFinite(amount)) {
      return '';
    }

    if (getLocale() === 'fr') {
      let value = (
        amount / 100
      ).toFixed(2);

      value = value
        .replace(/\.00$/, '')
        .replace(/(\.\d)0$/, '$1')
        .replace('.', ',');

      return `${value}€`;
    }

    return `€${(
      amount / 100
    ).toFixed(2)}`;
  };

  /* ========================================================
     Hydrate add-on pricing
     ======================================================== */

  const getHydrateCatalogPrice = (
    component
  ) => {
    const price = Number(
      component.dataset
        .hydrateCatalogPrice || 0
    );

    return (
      Number.isFinite(price) &&
      price > 0
    )
      ? price
      : 0;
  };

  const getHydratePriceForPack = (
    component,
    packCount
  ) => {
    if (packCount === 1) {
      return getHydrateCatalogPrice(
        component
      );
    }

    const price = Number(
      component.getAttribute(
        `data-hydrate-upsell-price-${packCount}`
      ) || 0
    );

    if (
      Number.isFinite(price) &&
      price > 0
    ) {
      return price;
    }

    console.warn(
      `[KHU Kick] Missing Hydrate upsell price for ${packCount} boxes. Falling back to catalogue price.`
    );

    return getHydrateCatalogPrice(
      component
    );
  };

  /* ========================================================
     KQV
     ======================================================== */

  const getPicker = (
    component
  ) => {
    const productId =
      component.dataset.productId;

    if (!productId) {
      return null;
    }

    return document.querySelector(
      `.kqv[data-product-id="${productId}"]`
    );
  };

  const getSelectedCard = (
    picker
  ) => {
    if (!picker) {
      return null;
    }

    return picker.querySelector(
      '[data-kqv-card].is-selected:not([hidden])'
    );
  };

  const getPackCount = (
    card
  ) => {
    if (!card) {
      return null;
    }

    const rawValue =
      card.dataset.packKey ||
      card.querySelector(
        '.kqv__pack-title'
      )?.textContent ||
      '';

    const match =
      String(rawValue).match(
        /\d+/
      );

    if (!match) {
      return null;
    }

    const count =
      Number(match[0]);

    return Number.isFinite(
      count
    )
      ? count
      : null;
  };

  const getPurchaseType = (
    picker,
    packCount
  ) => {
    if (
      !picker ||
      packCount === 1
    ) {
      return 'one-time';
    }

    if (
      picker.dataset
        .kqvPurchaseType ===
      'subscription'
    ) {
      return 'subscription';
    }

    const selected =
      picker.querySelector(
        '[data-kqv-purchase-option].is-selected'
      );

    return selected?.dataset
      .purchaseType ===
      'subscription'
      ? 'subscription'
      : 'one-time';
  };

  const getState = (
    packCount,
    purchaseType
  ) => {
    const normalizedPurchaseType =
      packCount === 1
        ? 'one-time'
        : purchaseType;

    return {
      key:
        `${packCount}-${normalizedPurchaseType}`,

      purchaseType:
        normalizedPurchaseType,
    };
  };

  /* ========================================================
     Hydrate add-on
     ======================================================== */

  const getHydrateCard = (
    component
  ) => {
    return component.querySelector(
      '[data-khu-hydrate]'
    );
  };

  const isHydrateSelected = (
    component
  ) => {
    return Boolean(
      getHydrateCard(
        component
      )?.classList.contains(
        'is-selected'
      )
    );
  };

  const updateHydrateButtonState = (
    component
  ) => {
    const copy =
      COPY[getLocale()];

    const selected =
      isHydrateSelected(
        component
      );

    const button =
      component.querySelector(
        '[data-khu-hydrate-toggle]'
      );

    const label =
      component.querySelector(
        '[data-khu-hydrate-button-label]'
      );

    if (
      !button ||
      !label
    ) {
      return;
    }

    label.textContent =
      selected
        ? copy.hydrateRemove
        : copy.hydrateAdd;

    button.classList.toggle(
      'is-selected',
      selected
    );

    button.setAttribute(
      'aria-pressed',
      selected
        ? 'true'
        : 'false'
    );
  };

  const updateHydrateInfo = (
    component
  ) => {
    const popup =
      component.querySelector(
        '[data-khu-hydrate-info]'
      );

    if (!popup) {
      return;
    }

    const copy =
      COPY[getLocale()];

    const popupCopy =
      copy.popup;

    const title =
      popup.querySelector(
        '[data-khu-info-title]'
      );

    const text =
      popup.querySelector(
        '[data-khu-info-text]'
      );

    const sodium =
      popup.querySelector(
        '[data-khu-info-fact-sodium]'
      );

    const potassium =
      popup.querySelector(
        '[data-khu-info-fact-potassium]'
      );

    const magnesium =
      popup.querySelector(
        '[data-khu-info-fact-magnesium]'
      );

    const cta =
      popup.querySelector(
        '[data-khu-info-cta]'
      );

    if (title) {
      title.textContent =
        popupCopy.title;
    }

    if (text) {
      text.textContent =
        popupCopy.text;
    }

    if (sodium) {
      sodium.textContent =
        popupCopy.sodium;
    }

    if (potassium) {
      potassium.textContent =
        popupCopy.potassium;
    }

    if (magnesium) {
      magnesium.textContent =
        popupCopy.magnesium;
    }

    if (!cta) {
      return;
    }

    const selected =
      isHydrateSelected(
        component
      );

    const packCount =
      Number(
        component.dataset
          .khuPack || 0
      );

    const hydratePrice =
      getHydratePriceForPack(
        component,
        packCount
      );

    cta.textContent =
      selected
        ? popupCopy.remove
        : `${popupCopy.add} +${formatMoney(
            hydratePrice
          )}`;
  };

  const openHydrateInfo = (
    component
  ) => {
    const popup =
      component.querySelector(
        '[data-khu-hydrate-info]'
      );

    if (!popup) {
      return;
    }

    updateHydrateInfo(
      component
    );

    popup.classList.add(
      'is-open'
    );

    popup.setAttribute(
      'aria-hidden',
      'false'
    );

    document.body.classList.add(
      'khu-info-open'
    );

    requestAnimationFrame(
      () => {
        popup
          .querySelector(
            '[data-khu-hydrate-info-close]'
          )
          ?.focus();
      }
    );
  };

  const closeHydrateInfo = (
    component
  ) => {
    const popup =
      component.querySelector(
        '[data-khu-hydrate-info]'
      );

    if (!popup) {
      return;
    }

    popup.classList.remove(
      'is-open'
    );

    popup.setAttribute(
      'aria-hidden',
      'true'
    );

    document.body.classList.remove(
      'khu-info-open'
    );

    component
      .querySelector(
        '[data-khu-hydrate-info-open]'
      )
      ?.focus();
  };

  const resetHydrate = (
    component
  ) => {
    getHydrateCard(
      component
    )?.classList.remove(
      'is-selected'
    );

    updateHydrateButtonState(
      component
    );
  };

  const syncHydrate = (
    component,
    state,
    stateCopy,
    packCount
  ) => {
    const copy =
      COPY[getLocale()];

    const title =
      component.querySelector(
        '[data-khu-hydrate-title]'
      );

    const body =
      component.querySelector(
        '[data-khu-hydrate-body]'
      );

    const price =
      component.querySelector(
        '[data-khu-hydrate-price]'
      );

    const link =
      component.querySelector(
        '[data-khu-hydrate-link]'
      );

    const hydratePrice =
      getHydratePriceForPack(
        component,
        packCount
      );

    if (title) {
      title.textContent =
        stateCopy.title;
    }

    if (body) {
      body.textContent =
        stateCopy.body;
    }

    if (link) {
      link.textContent =
        copy.hydrateLink;
    }

    if (price) {
      price.textContent =
        `+${formatMoney(
          hydratePrice
        )}`;
    }

    component.dataset
      .khuHydratePrice =
      String(hydratePrice);

    component.dataset
      .khuPurchaseType =
      state.purchaseType;

    updateHydrateButtonState(
      component
    );

    updateHydrateInfo(
      component
    );
  };

  /* ========================================================
     Bottle
     ======================================================== */

  const getBottle = (
    component
  ) => {
    return component.querySelector(
      '[data-khu-bottle]'
    );
  };

  const isBottleSelected = (
    component
  ) => {
    return (
      getBottle(
        component
      )?.dataset
        .bottleSelected ===
      'true'
    );
  };

  const setBottleSelected = (
    component,
    selected
  ) => {
    const bottle =
      getBottle(component);

    if (!bottle) {
      return;
    }

    bottle.dataset
      .bottleSelected =
      selected
        ? 'true'
        : 'false';

    bottle.classList.toggle(
      'is-selected',
      selected
    );
  };

  const getBottleQuantity = (
    component
  ) => {
    const quantity = Number(
      getBottle(
        component
      )?.dataset
        .bottleQuantity ||
      1
    );

    return (
      Number.isFinite(
        quantity
      ) &&
      quantity > 0
    )
      ? quantity
      : 1;
  };

  const setBottleQuantity = (
    component,
    quantity
  ) => {
    const bottle =
      getBottle(component);

    if (!bottle) {
      return;
    }

    const safeQuantity =
      Math.max(
        1,
        Math.floor(
          Number(quantity) || 1
        )
      );

    bottle.dataset
      .bottleQuantity =
      String(safeQuantity);

    const output =
      bottle.querySelector(
        '[data-khu-bottle-quantity]'
      );

    if (output) {
      output.textContent =
        String(safeQuantity);
    }
  };

  const getSelectedBottleVariant =
    (component) => {
      return component.querySelector(
        '[data-khu-bottle-variant].is-selected'
      );
    };

  const getBottleUnitPrice = (
    component
  ) => {
    const selectedVariant =
      getSelectedBottleVariant(
        component
      );

    const price = Number(
      selectedVariant?.dataset
        .price ||
      getBottle(
        component
      )?.dataset
        .bottleUnitPrice ||
      0
    );

    return (
      Number.isFinite(
        price
      ) &&
      price > 0
    )
      ? price
      : 0;
  };

  const updateBottlePrice = (
    component
  ) => {
    const bottle =
      getBottle(component);

    if (!bottle) {
      return;
    }

    const price =
      bottle.querySelector(
        '[data-khu-bottle-price]'
      );

    if (!price) {
      return;
    }

    const isSubscription =
      component.dataset
        .khuPurchaseType ===
      'subscription';

    const copy =
      COPY[getLocale()];

    const unitPrice =
      getBottleUnitPrice(
        component
      );

    const quantity =
      getBottleQuantity(
        component
      );

    if (isSubscription) {
      const paidQuantity =
        Math.max(
          0,
          quantity - 1
        );

      if (
        paidQuantity === 0
      ) {
        price.textContent =
          copy.bottleFreePrice;
      } else {
        price.textContent =
          `${copy.bottleFreePrice} + ${formatMoney(
            unitPrice *
            paidQuantity
          )}`;
      }

      return;
    }

    price.textContent =
      formatMoney(
        unitPrice
      );
  };

  const updateBottleControls = (
    component
  ) => {
    const bottle =
      getBottle(component);

    if (!bottle) {
      return;
    }

    const copy =
      COPY[getLocale()];

    const addButton =
      bottle.querySelector(
        '[data-khu-bottle-add]'
      );

    const addLabel =
      bottle.querySelector(
        '[data-khu-bottle-add-label]'
      );

    const stepper =
      bottle.querySelector(
        '[data-khu-bottle-stepper]'
      );

    const minus =
      bottle.querySelector(
        '[data-khu-bottle-minus]'
      );

    const plus =
      bottle.querySelector(
        '[data-khu-bottle-plus]'
      );

    const isSubscription =
      component.dataset
        .khuPurchaseType ===
      'subscription';

    const selected =
      isBottleSelected(
        component
      );

    const quantity =
      getBottleQuantity(
        component
      );

    if (addLabel) {
      addLabel.textContent =
        copy.bottleAdd;
    }

    if (isSubscription) {
      if (addButton) {
        addButton.hidden = true;

        addButton.setAttribute(
          'aria-pressed',
          'true'
        );
      }

      if (stepper) {
        stepper.hidden = false;
      }

      if (minus) {
        minus.disabled =
          quantity <= 1;
      }

      if (plus) {
        plus.disabled = false;
      }

      return;
    }

    if (addButton) {
      addButton.hidden =
        selected;

      addButton.setAttribute(
        'aria-pressed',
        selected
          ? 'true'
          : 'false'
      );
    }

    if (stepper) {
      stepper.hidden =
        !selected;
    }

    if (minus) {
      minus.disabled =
        false;
    }

    if (plus) {
      plus.disabled =
        false;
    }
  };

  const syncBottle = (
    component,
    purchaseType,
    previousPurchaseType
  ) => {
    const bottle =
      getBottle(component);

    if (!bottle) {
      return;
    }

    const isSubscription =
      purchaseType ===
      'subscription';

    bottle.classList.toggle(
      'is-free',
      isSubscription
    );

    if (isSubscription) {
      setBottleSelected(
        component,
        true
      );

      if (
        previousPurchaseType !==
        'subscription'
      ) {
        setBottleQuantity(
          component,
          1
        );
      }
    } else if (
      previousPurchaseType ===
      'subscription'
    ) {
      setBottleSelected(
        component,
        false
      );

      setBottleQuantity(
        component,
        1
      );
    } else if (
      !bottle.dataset
        .bottleSelected
    ) {
      setBottleSelected(
        component,
        false
      );

      setBottleQuantity(
        component,
        1
      );
    }

    updateBottlePrice(
      component
    );

    updateBottleControls(
      component
    );
  };

  const selectBottleVariant = (
    component,
    button
  ) => {
    if (
      !button ||
      button.disabled ||
      button.dataset
        .available !==
        'true'
    ) {
      return;
    }

    const bottle =
      getBottle(component);

    if (!bottle) {
      return;
    }

    bottle
      .querySelectorAll(
        '[data-khu-bottle-variant]'
      )
      .forEach(
        (item) => {
          const selected =
            item === button;

          item.classList.toggle(
            'is-selected',
            selected
          );

          item.setAttribute(
            'aria-checked',
            selected
              ? 'true'
              : 'false'
          );
        }
      );

    bottle.dataset
      .bottleVariantId =
      button.dataset
        .variantId ||
      '';

    bottle.dataset
      .bottleUnitPrice =
      button.dataset.price ||
      bottle.dataset
        .bottleUnitPrice ||
      '';

    const imageSrc =
      button.dataset
        .imageSrc ||
      '';

    const image =
      bottle.querySelector(
        '[data-khu-bottle-image]'
      );

    if (
      image &&
      imageSrc
    ) {
      image.src =
        imageSrc;

      image.removeAttribute(
        'srcset'
      );
    }

    updateBottlePrice(
      component
    );

    updateAtc(
      component
    );

    emitChange(
      component
    );
  };

  /* ========================================================
     Primary Kick pricing
     ======================================================== */

  const getSinglePackCard = (
    picker
  ) => {
    if (!picker) {
      return null;
    }

    return (
      Array.from(
        picker.querySelectorAll(
          '[data-kqv-card]'
        )
      ).find(
        (card) =>
          getPackCount(
            card
          ) === 1
      ) ||
      null
    );
  };

  const getPrimaryPrice = (
    card,
    purchaseType
  ) => {
    if (!card) {
      return 0;
    }

    if (
      purchaseType ===
        'subscription' &&
      card.dataset
        .subscriptionAvailable ===
        'true'
    ) {
      const subscriptionPrice =
        Number(
          card.dataset
            .subscriptionPrice ||
          0
        );

      if (
        subscriptionPrice > 0
      ) {
        return subscriptionPrice;
      }
    }

    return Number(
      card.dataset.price ||
      0
    );
  };

  const getPrimaryReferencePrice = (
    picker,
    card
  ) => {
    if (
      !picker ||
      !card
    ) {
      return 0;
    }

    const packCount =
      getPackCount(card);

    const singlePackPrice =
      Number(
        getSinglePackCard(
          picker
        )?.dataset.price ||
        0
      );

    if (
      packCount > 1 &&
      singlePackPrice > 0
    ) {
      return (
        singlePackPrice *
        packCount
      );
    }

    return Number(
      card.dataset.price ||
      0
    );
  };

  const getProductForm = (
    picker
  ) => {
    if (!picker) {
      return null;
    }

    const formId =
      picker.dataset
        .productFormId;

    if (formId) {
      const element =
        document.getElementById(
          formId
        );

      if (
        element?.tagName ===
        'FORM'
      ) {
        return element;
      }

      const nestedForm =
        element
          ?.querySelector?.(
            'form'
          );

      if (nestedForm) {
        return nestedForm;
      }
    }

    return (
      picker.closest('form') ||
      picker
        .closest(
          'product-form'
        )
        ?.querySelector(
          'form'
        ) ||
      null
    );
  };

  /* ========================================================
     ATC
     ======================================================== */

  const updateAtc = (
    component
  ) => {
    if (
      !isEnabled(component) ||
      component.hidden
    ) {
      return;
    }

    const picker =
      getPicker(component);

    const card =
      getSelectedCard(
        picker
      );

    if (
      !picker ||
      !card
    ) {
      return;
    }

    const packCount =
      getPackCount(card);

    const purchaseType =
      getPurchaseType(
        picker,
        packCount
      );

    const hydrateSelected =
      isHydrateSelected(
        component
      );

    let productTotal =
      getPrimaryPrice(
        card,
        purchaseType
      );

    let referenceTotal =
      getPrimaryReferencePrice(
        picker,
        card
      );

    if (hydrateSelected) {
      productTotal +=
        getHydratePriceForPack(
          component,
          packCount
        );

      referenceTotal +=
        getHydrateCatalogPrice(
          component
        );
    }

    const discount =
      referenceTotal >
        productTotal &&
      referenceTotal > 0
        ? Math.round(
            (
              (
                referenceTotal -
                productTotal
              ) /
              referenceTotal
            ) *
              100
          )
        : 0;

    let buttonTotal =
      productTotal;

    let displayReferenceTotal =
      referenceTotal;

    if (
      isBottleSelected(
        component
      )
    ) {
      const bottleQuantity =
        getBottleQuantity(
          component
        );

      const paidBottleQuantity =
        purchaseType ===
          'subscription'
          ? Math.max(
              0,
              bottleQuantity - 1
            )
          : bottleQuantity;

      const paidBottleTotal =
        getBottleUnitPrice(
          component
        ) *
        paidBottleQuantity;

      buttonTotal +=
        paidBottleTotal;

      displayReferenceTotal +=
        paidBottleTotal;
    }

    const form =
      getProductForm(
        picker
      );

    if (!form) {
      return;
    }

    const atcLabel =
      form.querySelector(
        '.atc-label'
      );

    const atcDiscount =
      form.querySelector(
        '.qty-test-atc__discount'
      );

    const addToCartLabel =
      picker.dataset
        .labelAddToCart ||
      'Add to cart';

    if (atcLabel) {
      const showCompare =
        discount > 0 &&
        displayReferenceTotal > 0;

      atcLabel.innerHTML = `
        <span class="qty-test-atc__main">
          ${addToCartLabel} · <span class="qty-test-atc__price">${formatMoney(
            buttonTotal
          )}</span>
        </span>

        <span class="qty-test-atc__compare"${
          showCompare
            ? ''
            : ' hidden'
        }>
          ${
            showCompare
              ? formatMoney(
                  displayReferenceTotal
                )
              : ''
          }
        </span>
      `;
    }

    if (atcDiscount) {
      if (discount > 0) {
        atcDiscount.textContent =
          `-${discount}%`;

        atcDiscount.hidden =
          false;
      } else {
        atcDiscount.textContent =
          '';

        atcDiscount.hidden =
          true;
      }
    }
  };

  /* ========================================================
     State event
     ======================================================== */

  const emitChange = (
    component
  ) => {
    const selectedBottle =
      getSelectedBottleVariant(
        component
      );

    document.dispatchEvent(
      new CustomEvent(
        'kaiju:kick-upsell-change',
        {
          bubbles: true,

          detail: {
            productId:
              component.dataset
                .productId ||
              '',

            packCount:
              Number(
                component.dataset
                  .khuPack ||
                0
              ),

            purchaseType:
              component.dataset
                .khuPurchaseType ||
              'one-time',

            hydrate: {
              selected:
                isHydrateSelected(
                  component
                ),

              variantId:
                component.dataset
                  .hydrateVariantId ||
                '',

              price:
                Number(
                  component.dataset
                    .khuHydratePrice ||
                  0
                ),
            },

            bottle: {
              selected:
                isBottleSelected(
                  component
                ),

              variantId:
                selectedBottle
                  ?.dataset
                  .variantId ||
                '',

              quantity:
                getBottleQuantity(
                  component
                ),

              unitPrice:
                getBottleUnitPrice(
                  component
                ),

              free:
                component.dataset
                  .khuPurchaseType ===
                'subscription',
            },
          },
        }
      )
    );
  };

  /* ========================================================
     Sync
     ======================================================== */

  const syncComponent = (
    component
  ) => {
    if (!isEnabled(component)) {
      component.hidden =
        true;

      return;
    }

    const picker =
      getPicker(
        component
      );

    const selectedCard =
      getSelectedCard(
        picker
      );

    if (
      !picker ||
      !selectedCard
    ) {
      component.hidden =
        true;

      return;
    }

    const packCount =
      getPackCount(
        selectedCard
      );

    if (
      ![1, 3, 6].includes(
        packCount
      )
    ) {
      component.hidden =
        true;

      return;
    }

    const purchaseType =
      getPurchaseType(
        picker,
        packCount
      );

    const state =
      getState(
        packCount,
        purchaseType
      );

    const copy =
      COPY[getLocale()];

    const stateCopy =
      copy[state.key];

    if (!stateCopy) {
      component.hidden =
        true;

      return;
    }

    const previousState =
      component.dataset
        .khuState ||
      '';

    const previousPurchaseType =
      component.dataset
        .khuPurchaseType ||
      '';

    if (
      previousState &&
      previousState !==
        state.key
    ) {
      resetHydrate(
        component
      );
    }

    component.dataset
      .khuState =
      state.key;

    component.dataset
      .khuPack =
      String(packCount);

    component.dataset
      .khuPurchaseType =
      state.purchaseType;

    syncHydrate(
      component,
      state,
      stateCopy,
      packCount
    );

    syncBottle(
      component,
      state.purchaseType,
      previousPurchaseType
    );

    component.hidden =
      false;

    updateAtc(
      component
    );
  };

  /* ========================================================
     Cart transformer
     ======================================================== */

  const registerCartTransformer =
    () => {
      const api =
        window
          .__kqvCartFetchPatchApi;

      if (
        !api
          ?.registerCartTransformer ||
        window
          .__khuKickPageCartTransformerRegistered
      ) {
        return Boolean(
          window
            .__khuKickPageCartTransformerRegistered
        );
      }

      api.registerCartTransformer(
        ({
          payload,
          variantId,
        }) => {
          if (
            !Array.isArray(
              payload?.items
            )
          ) {
            return null;
          }

          const component =
            Array.from(
              document.querySelectorAll(
                '[data-kick-hydrate-upsell]'
              )
            ).find(
              (candidate) => {
                if (
                  candidate.hidden
                ) {
                  return false;
                }

                const picker =
                  getPicker(
                    candidate
                  );

                const selectedCard =
                  getSelectedCard(
                    picker
                  );

                return (
                  selectedCard &&
                  String(
                    selectedCard
                      .dataset
                      .variantId
                  ) ===
                    String(
                      variantId
                    )
                );
              }
            );

          if (
            !component ||
            !isEnabled(component)
          ) {
            return null;
          }

          const picker =
            getPicker(
              component
            );

          const selectedCard =
            getSelectedCard(
              picker
            );

          const packCount =
            getPackCount(
              selectedCard
            );

          const purchaseType =
            getPurchaseType(
              picker,
              packCount
            );

          const hydrateSelected =
            isHydrateSelected(
              component
            );

          const items =
            payload.items.map(
              (item) => ({
                ...item,

                properties:
                  item.properties
                    ? {
                        ...item
                          .properties,
                      }
                    : undefined,
              })
            );

          let changed =
            false;

          if (hydrateSelected) {
            const hydrateVariantId =
              Number(
                component.dataset
                  .hydrateVariantId ||
                0
              );

            if (
              Number.isFinite(
                hydrateVariantId
              ) &&
              hydrateVariantId > 0
            ) {
              items.push({
                id:
                  hydrateVariantId,

                quantity: 1,

                properties: {
                  _khu_offer:
                    'kick-upsell',

                  _khu_role:
                    'hydrate-add',

                  _khu_pack:
                    String(
                      packCount
                    ),

                  _khu_purchase_type:
                    purchaseType,
                },
              });

              changed =
                true;
            }
          }

          const bottle =
            getBottle(
              component
            );

          const bottleVariantId =
            Number(
              bottle?.dataset
                .bottleVariantId ||
              0
            );

          const shouldAddBottle =
            purchaseType ===
              'subscription' ||
            isBottleSelected(
              component
            );

          const bottleQuantity =
            getBottleQuantity(
              component
            );

          if (
            shouldAddBottle &&
            Number.isFinite(
              bottleVariantId
            ) &&
            bottleVariantId > 0 &&
            bottleQuantity > 0
          ) {
            items.push({
              id:
                bottleVariantId,

              quantity:
                bottleQuantity,

              properties: {
                _khu_offer:
                  'kick-upsell',

                _khu_role:
                  purchaseType ===
                  'subscription'
                    ? 'free-bottle'
                    : 'paid-bottle',

                _khu_purchase_type:
                  purchaseType,
              },
            });

            changed =
              true;
          }

          if (!changed) {
            return null;
          }

          return {
            payload: {
              ...payload,
              items,
            },

            variantId,
          };
        }
      );

      window
        .__khuKickPageCartTransformerRegistered =
        true;

      return true;
    };

  /* ========================================================
     Init
     ======================================================== */

  const initComponent = (
    component
  ) => {
    if (
      component.dataset
        .khuKickPageInitialized ===
      'true'
    ) {
      syncComponent(
        component
      );

      return;
    }

    component.dataset
      .khuKickPageInitialized =
      'true';

    /* Hydrate */

    const hydrateButton =
      component.querySelector(
        '[data-khu-hydrate-toggle]'
      );

    const hydrateCard =
      getHydrateCard(
        component
      );

    hydrateButton?.addEventListener(
      'click',
      (event) => {
        event.preventDefault();

        const selected =
          !hydrateCard
            ?.classList.contains(
              'is-selected'
            );

        hydrateCard?.classList.toggle(
          'is-selected',
          selected
        );

        updateHydrateButtonState(
          component
        );

        updateHydrateInfo(
          component
        );

        updateAtc(
          component
        );

        emitChange(
          component
        );
      }
    );

    /* Hydrate info popup */

    const infoOpen =
      component.querySelector(
        '[data-khu-hydrate-info-open]'
      );

    infoOpen?.addEventListener(
      'click',
      (event) => {
        event.preventDefault();

        openHydrateInfo(
          component
        );
      }
    );

    component
      .querySelectorAll(
        '[data-khu-hydrate-info-close]'
      )
      .forEach(
        (button) => {
          button.addEventListener(
            'click',
            (event) => {
              event.preventDefault();

              closeHydrateInfo(
                component
              );
            }
          );
        }
      );

    const infoCta =
      component.querySelector(
        '[data-khu-info-cta]'
      );

    infoCta?.addEventListener(
      'click',
      (event) => {
        event.preventDefault();

        hydrateButton?.click();

        closeHydrateInfo(
          component
        );
      }
    );

    /* Bottle variants */

    component
      .querySelectorAll(
        '[data-khu-bottle-variant]'
      )
      .forEach(
        (button) => {
          button.addEventListener(
            'click',
            (event) => {
              event.preventDefault();

              selectBottleVariant(
                component,
                button
              );
            }
          );
        }
      );

    /* Bottle add */

    const bottleAdd =
      component.querySelector(
        '[data-khu-bottle-add]'
      );

    bottleAdd?.addEventListener(
      'click',
      (event) => {
        event.preventDefault();

        if (
          component.dataset
            .khuPurchaseType ===
          'subscription'
        ) {
          return;
        }

        setBottleSelected(
          component,
          true
        );

        setBottleQuantity(
          component,
          1
        );

        updateBottleControls(
          component
        );

        updateAtc(
          component
        );

        emitChange(
          component
        );
      }
    );

    /* Bottle quantity */

    const bottleMinus =
      component.querySelector(
        '[data-khu-bottle-minus]'
      );

    const bottlePlus =
      component.querySelector(
        '[data-khu-bottle-plus]'
      );

    bottleMinus?.addEventListener(
      'click',
      (event) => {
        event.preventDefault();

        const isSubscription =
          component.dataset
            .khuPurchaseType ===
          'subscription';

        const current =
          getBottleQuantity(
            component
          );

        if (isSubscription) {
          if (current <= 1) {
            return;
          }

          setBottleQuantity(
            component,
            current - 1
          );
        } else {
          if (
            current <= 1
          ) {
            setBottleSelected(
              component,
              false
            );

            setBottleQuantity(
              component,
              1
            );
          } else {
            setBottleQuantity(
              component,
              current - 1
            );
          }
        }

        updateBottlePrice(
          component
        );

        updateBottleControls(
          component
        );

        updateAtc(
          component
        );

        emitChange(
          component
        );
      }
    );

    bottlePlus?.addEventListener(
      'click',
      (event) => {
        event.preventDefault();

        const isSubscription =
          component.dataset
            .khuPurchaseType ===
          'subscription';

        if (
          !isSubscription &&
          !isBottleSelected(
            component
          )
        ) {
          return;
        }

        setBottleQuantity(
          component,
          getBottleQuantity(
            component
          ) + 1
        );

        updateBottlePrice(
          component
        );

        updateBottleControls(
          component
        );

        updateAtc(
          component
        );

        emitChange(
          component
        );
      }
    );

    syncComponent(
      component
    );
  };

  const initAll = (
    root = document
  ) => {
    root
      .querySelectorAll(
        '[data-kick-hydrate-upsell]'
      )
      .forEach(
        initComponent
      );
  };

  /* ========================================================
     Watch KQV
     ======================================================== */

  let syncFrame =
    null;

  const scheduleSync =
    () => {
      if (syncFrame) {
        cancelAnimationFrame(
          syncFrame
        );
      }

      syncFrame =
        requestAnimationFrame(
          () => {
            syncFrame =
              null;

            document
              .querySelectorAll(
                '[data-kick-hydrate-upsell]'
              )
              .forEach(
                syncComponent
              );
          }
        );
    };

  document.addEventListener(
    'click',
    (event) => {
      const trigger =
        event.target.closest(
          '[data-kqv-card], [data-kqv-purchase-option]'
        );

      if (!trigger) {
        return;
      }

      scheduleSync();
    }
  );

  document.addEventListener(
    'change',
    (event) => {
      if (
        !event.target.closest(
          '.kqv'
        )
      ) {
        return;
      }

      scheduleSync();
    }
  );

  document.addEventListener(
    'keydown',
    (event) => {
      if (
        event.key !== 'Escape'
      ) {
        return;
      }

      document
        .querySelectorAll(
          '[data-kick-hydrate-upsell]'
        )
        .forEach(
          (component) => {
            const popup =
              component.querySelector(
                '[data-khu-hydrate-info].is-open'
              );

            if (popup) {
              closeHydrateInfo(
                component
              );
            }
          }
        );
    }
  );

  /* ========================================================
     Boot
     ======================================================== */

  const boot = () => {
    initAll(document);

    registerCartTransformer();

    requestAnimationFrame(
      scheduleSync
    );

    setTimeout(
      registerCartTransformer,
      100
    );

    setTimeout(
      registerCartTransformer,
      500
    );

    setTimeout(
      registerCartTransformer,
      1200
    );
  };

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      boot
    );
  } else {
    boot();
  }

  window.addEventListener(
    'load',
    () => {
      registerCartTransformer();
      scheduleSync();
    }
  );

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initAll(
        event.target
      );

      registerCartTransformer();

      scheduleSync();
    }
  );

  document.addEventListener(
    'shopify:section:select',
    (event) => {
      initAll(
        event.target
      );

      registerCartTransformer();

      scheduleSync();
    }
  );
})();